// Etats actifs des boutons selon le SKU, modales de la fiche produit, declenchement du sticky bundle.
//
// NETTOYAGE DU 28/07/2026. Le fichier ouvrait sur un calcul de date de livraison (getISODate,
// addWorkingDays, injection dans #livraison) : ce span a disparu avec les anciennes popins, et le
// calcul actif vit desormais dans assets/dd-logistique.js, qui tient compte du fuseau Europe/Paris,
// du cutoff et des jours feries. Le meme code dormait dans assets/custom-delivery-dates.js.liquid,
// charge par aucun layout ni aucune section, supprime au passage.
// Retire en meme temps : le bloc qui posait la classe active sur #boutonCabine et consorts d'apres le
// texte suivant .text-subdued. Ces identifiants n'existent plus depuis que les boutons de taille sont
// rendus par dd-size-buttons, et l'appel n'etait pas garde : il levait une TypeError des que la
// comparaison de texte reussissait, ce qui interrompait tout le reste du fichier.
//
// Les blocs #bouton... conserves ci-dessous sont eux aussi sans effet sur les fiches valise, mais ils
// sont laisses en place : rien ne prouve qu'aucun autre template ne pose ces identifiants a la main.
// Ils recoivent en revanche la garde de nullite qui leur manquait.

function ddActiver(selecteur) {
  var el = document.querySelector(selecteur);
  if (el) el.classList.add('active');
}

// Lecture du SKU affiche. Le div #product-sku est absent de 10 templates produit, dont product.json
// (le defaut) et bundle-landing-v1. Sans cette garde, chaque clic sur un radio du selecteur de
// variantes levait une TypeError qui interrompait le reste de l'ecouteur : la lecture initiale etait
// gardee, les trois relectures des ecouteurs 'change' ne l'etaient pas.
function ddSku() {
  var el = document.getElementById('product-sku');
  return el ? el.textContent.trim() : "";
}

window.onload = function() {
    const productSKU = ddSku();

    function updateButtonStates(sku) {
        document.querySelectorAll('.size-button').forEach(button => button.classList.remove('active'));

        if (sku.includes("553520")) {
            ddActiver('#boutonCabine');
        } else if (sku.includes("554020")) {
            ddActiver('#boutonCabinePlus');
        } else if (sku.includes("664827")) {
            ddActiver('#boutonMedium');
        } else if (sku.includes("765531")) {
            ddActiver('#boutonLarge');
        }

        if (sku.includes("-")) {
            ddActiver('#boutonAvecPochettes');
        } else {
            ddActiver('#boutonSansPochette');
        }
    }

    updateButtonStates(productSKU);

    document.addEventListener('change', function(event) {
    if (event.target.matches('.variant-picker__option-values input[type="radio"]')) {
        const updatedSKU = ddSku();
        updateButtonStates(updatedSKU);
    }
  });
};

document.addEventListener('DOMContentLoaded', function() {
    function updateButtonStates(sku) {
        if (sku.includes("EDOTS01")) {
            ddActiver('#boutonPochCabine');
        } else if (sku.includes("EDOTSXL")) {
            ddActiver('#boutonPochCabinePlus');
        } else if (sku.includes("EDOTM")) {
            ddActiver('#boutonPochMedium');
        } else if (sku.includes("EDOTL")) {
            ddActiver('#boutonPochLarge');
        }
    }

    const productSKU = ddSku();
    updateButtonStates(productSKU);

    document.addEventListener('change', function(event) {
        if (event.target.matches('.variant-picker__option-values input[type="radio"]')) {
            const updatedSKU = ddSku();
            updateButtonStates(updatedSKU);
        }
    });
});

document.addEventListener('DOMContentLoaded', function() {
    function updateButtonStates(sku) {
        if (sku.includes("EDOTS")) {
            ddActiver('#boutonDotCabine');
        } else if (sku.includes("EDOTM")) {
            ddActiver('#boutonDotMedium');
        } else if (sku.includes("EDOTL")) {
            ddActiver('#boutonDotLarge');
        }
    }

    const productSKU = ddSku();
    updateButtonStates(productSKU);

    document.addEventListener('change', function(event) {
        if (event.target.matches('.variant-picker__option-values input[type="radio"]')) {
            const updatedSKU = ddSku();
            updateButtonStates(updatedSKU);
        }
    });
});

window.addEventListener('loadPopup', function() {
    globalModal();
});

function globalModal() {
    document.querySelectorAll('[data-modal-target]').forEach(button => {
        button.addEventListener('click', function(event) {
            event.preventDefault(); // Empêche le comportement par défaut
            const modalId = this.getAttribute('data-modal-target');
            const modal = document.getElementById(modalId);
            if (!modal) return; // popin absente de cette page : on ne fait rien
            modal.style.display = 'block'; // Affiche le modal
            const overlayOpen = document.querySelector('.modal-overlay');
            if (overlayOpen) overlayOpen.style.display = 'block'; // Affiche l'overlay
        });
    });

    // Fermer les modals au clic sur le bouton fermer
    document.querySelectorAll('.close_multi').forEach(button => {
        button.addEventListener('click', function() {
            const modal = this.closest('.modal_multi');
            if (modal) {
                modal.style.display = 'none'; // Masque le modal
            }
            const overlayClose = document.querySelector('.modal-overlay');
            if (overlayClose) overlayClose.style.display = 'none'; // Masque l'overlay
        });
    });

    // Fermer les modals au clic sur l'overlay
    // Sans cette garde, une page depourvue d'overlay levait une TypeError qui
    // interrompait l'execution de tout le reste du fichier.
    const overlayEl = document.querySelector('.modal-overlay');
    if (overlayEl) overlayEl.addEventListener('click', function() {
        const modalsOpen = document.querySelectorAll('.modal_multi');
        modalsOpen.forEach(modal => {
            modal.style.display = 'none'; // Masque le modal
        });
        this.style.display = 'none'; // Masque l'overlay
    });
}

document.addEventListener('DOMContentLoaded', function() {
    globalModal();
});

// Sticky bundle : declenchement des que le titre "Taille :" est sorti (boutons encore visibles)
  (function () {
    var ticking = false;

    function update() {
      ticking = false;
      var bar = document.querySelector('.product-sticky-bundle');
      if (!bar) return;
      var sizes = document.querySelector('#button-suitcase-size-container');
      if (!sizes) { bar.classList.remove('is-visible'); return; }
      // Le titre "Taille :" est juste au-dessus du conteneur de boutons.
      // Des que le haut du conteneur franchit le haut de l'ecran, le titre est sorti
      // alors que les boutons restent visibles.
      var passed = sizes.getBoundingClientRect().top < 40;
      bar.classList.toggle('is-visible', passed);
    }

    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('DOMContentLoaded', update);

    // La barre et le selecteur sont re-rendus a chaque changement de variant
    document.body.addEventListener('product:rerender', function () {
      requestAnimationFrame(update);
    }, true);
  })();

